import Vue from 'vue'
import App from './App.vue'

Vue.config.productionTip = false;

import './plugins/element-ui/element.js'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
Vue.use(ElementUI);

import resetMessage from '@/utils/resetMessage'
Vue.prototype.$message = resetMessage;

import Variable from '@/utils/variable.js';
Vue.prototype.$variable = Variable

import router from './router'

import "@/styles/cm.less"

// import { getOneColumn, getSiteInfo } from "@/api/api.js";
// import { cmNavMenu, siteInfo, companyName } from "@/utils/auth.js";
// let methods = {
//   getNavMenu() {
//     getOneColumn({}).then((res) => {
//       localStorage.setItem(cmNavMenu, JSON.stringify(res));
//     });
//   },
//   loadSiteInfo() {
//     getSiteInfo({ current: 1, size: 10 }).then((res) => {
//       let info = res.records[0];
//       localStorage.setItem(siteInfo, JSON.stringify(info));
//       localStorage.setItem(companyName, info.company);
//     });
//   },
// };
// methods.getNavMenu();
// methods.loadSiteInfo();

new Vue({
  router,
  render: h => h(App),
}).$mount('#app')
